import { useState, FormEvent } from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { InputAdornment } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useAuth, useQuery } from '../App'
import AuthLayout from '../components/AuthLayout'
import { inputSx, primaryButtonSx } from '../styles/authSx'

const Reset = () => {
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const auth = useAuth()
  const query = useQuery()

  const passwordMismatch =
    passwordConfirm.length > 0 && password !== passwordConfirm
  const canSubmit =
    password.length >= 6 && password === passwordConfirm && !submitting

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!canSubmit) return
    setSubmitting(true)
    try {
      await auth?.resetPass(query.get('code'), password)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Choose a new password. You'll be signed in automatically."
    >
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <TextField
          fullWidth
          id="password"
          name="password"
          label="New password"
          type={showPassword ? 'text' : 'password'}
          autoComplete="new-password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={inputSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? 'Hide password' : 'Show password'
                  }
                  onClick={() => setShowPassword((v) => !v)}
                  edge="end"
                  size="small"
                  tabIndex={-1}
                  sx={(t) => ({
                    color:
                      t.palette.mode === 'dark' ? '#FFFFFF99' : '#6E6E73'
                  })}
                >
                  {showPassword ? (
                    <VisibilityOff fontSize="small" />
                  ) : (
                    <Visibility fontSize="small" />
                  )}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        <TextField
          fullWidth
          id="passwordConfirm"
          name="passwordConfirm"
          label="Confirm password"
          type={showPassword ? 'text' : 'password'}
          autoComplete="new-password"
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
          error={passwordMismatch}
          helperText={passwordMismatch ? "Passwords don't match" : ' '}
          sx={inputSx}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disableElevation
          disabled={!canSubmit}
          sx={(t) => ({ ...primaryButtonSx(t), mt: 1 })}
        >
          {submitting ? 'Resetting…' : 'Reset password'}
        </Button>
      </Box>
    </AuthLayout>
  )
}

export default Reset
